
export default {

    patient() {
        return window.restApi.get('v2/form/patient');
    },
    labsection() {
        return window.restApi.get('v2/form/labsection');
    },
    grouptest() {
        return window.restApi.get('v2/form/grouptest');
    },
    measure() {
        return window.restApi.get('v2/form/measure');
    },
    getFormSupplier() {
        return window.restApi.get('v2/form/supplier');
    },
    getFormProduk() {
        return window.restApi.get('v2/form/product');
    },
    getFormUOM() {
        return window.restApi.get('v2/form/uom');
    },
    getFormProdukGroup() {
        return window.restApi.get('v2/form/product/group');
    },
    getFormInstrument() {
        return window.restApi.get('v2/form/instrument');
    },
    getFormReagenMaster() {
        return window.restApi.get('v2/form/reagenmaster');
    },
    getFormSetting() {
        return window.restApi.get('v2/form/setting');
    },
    getFormDokter() {
        return window.restApi.get('v2/form/physician');
    },
    getFormRuangan() {
        return window.restApi.get('v2/form/ward');
    },
    getFormUser() {
        return window.restApi.get('v2/form/user');
    },
    getFormSuhu() {
        return window.restApi.get('v2/form/suhu');
    },
    getFormLokasi() {
        return window.restApi.get('v2/form/lokasi');
    },
    getFormKlasifikasi() {
        return window.restApi.get('v2/form/klasifikasi');
    },    
    getFormVolume() {
        return window.restApi.get('v2/form/volume');
    },        
    getFormSettingHarga() {
        return window.restApi.get('v2/form/pricesetting');
    },
}
